document.addEventListener('DOMContentLoaded', () => {

  const tagClouds = document.querySelectorAll('.nxa-block-tag-cloud');
  if (tagClouds.length === 0) return;

  tagClouds.forEach(tagCloud => {

    let animating = false;
    const links = tagCloud.querySelector('.links');
    const heightToggle = tagCloud.querySelector('.height-toggle');
    const icon = heightToggle.querySelector('svg');
    const showMore = heightToggle.querySelector('.show-more');
    const showLess = heightToggle.querySelector('.show-less');
    const maxHeight = () => window.matchMedia('(min-width: 768px)').matches ? 163 : 222;

    const updateUI = expanded => {
      heightToggle.setAttribute('aria-expanded', expanded);
      icon.classList.toggle('flip', expanded);
      showMore.style.display = expanded ? 'none' : '';
      showLess.style.display = expanded ? '' : 'none';
    };

    const resizeObserver = new ResizeObserver(() => {
      if (animating) return;
      if (links.scrollHeight > maxHeight() && heightToggle.getAttribute('aria-expanded') === 'false') {
        updateUI(false);
        heightToggle.removeAttribute('style');
        links.style.maxHeight = maxHeight() + 'px';
      }
      if (links.scrollHeight <= maxHeight()) {
        updateUI(false);
        heightToggle.style.display = 'none';
        links.style.maxHeight = '';
      }
    });
    resizeObserver.observe(links);

    const toggle = e => {
      if (!animating && (e.type === 'click' || e.key === 'Enter' || e.key === ' ')) {
        animating = true;
        if (links.clientHeight < links.scrollHeight) {
          updateUI(true);
          links.style.maxHeight = `${links.scrollHeight}px`;
          links.addEventListener('transitionend', () => {
            links.style.maxHeight = '';
            animating = false;
          }, { once: true });
        } else {
          updateUI(false);
          links.style.maxHeight = links.scrollHeight + 'px';
          requestAnimationFrame(() => {
            links.style.maxHeight = maxHeight() + 'px';
          })
          links.addEventListener('transitionend', () => {
            animating = false;
          }, { once: true });
        }
      }
    }
    heightToggle.addEventListener('keydown', toggle);
    heightToggle.addEventListener('click', toggle);

  });

});
